module.exports = require('./helpers/bundle-url').getBundleURL('drLhz') + "../assets/images/logo.6c573355.avif";